import email from './email/index';
import mobile from './mobile/index';
import Index from './index';
import LyIndex from './ly-index.vue';
import LyMobile from './mobile/ly-index.vue';
import LyEmail from './email/ly-index.vue';

export default [
  {
    path: '/forget',
    name: 'forget',
    component:Index,
  },
  {
    path: '/forget/email',
    name: 'auth-forget-email',
    component:email,
  },
  {
    path: '/forget/mobile',
    name: 'auth-forget-mobile',
    component:mobile,
  },
  {
    path: '/ly-forget',
    name: 'leyouforget',
    component:LyIndex,
  },
  {
    path: '/ly-forget/email',
    name: 'leyouauth-forget-email',
    component:LyEmail,
  },
  {
    path: '/ly-forget/mobile',
    name: 'leyouauth-forget-mobile',
    component:LyMobile,
  }
]
